export default "__VITE_ASSET__DG7j8QS8__"